
import { defineComponent } from "vue";
import ExampleText from "@/components/Example/ExampleText.vue";

export default defineComponent({
  name: "font-weight",
  components: {
    ExampleText,
  },
});
